import { render, staticRenderFns } from "./marketing-flag.vue?vue&type=template&id=6616d598&"
import script from "./marketing-flag.vue?vue&type=script&lang=js&"
export * from "./marketing-flag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6616d598')) {
      api.createRecord('6616d598', component.options)
    } else {
      api.reload('6616d598', component.options)
    }
    module.hot.accept("./marketing-flag.vue?vue&type=template&id=6616d598&", function () {
      api.rerender('6616d598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/marketing-flag.vue"
export default component.exports